import { render, staticRenderFns } from "./OfferType.vue?vue&type=template&id=0630148d&scoped=true&"
import script from "./OfferType.vue?vue&type=script&lang=js&"
export * from "./OfferType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630148d",
  null
  
)

export default component.exports